import { ApiError, apiFetch } from './client';
export async function getRegistrationTransform(ctSeriesUid, petSeriesUid) {
    try {
        return await apiFetch(`/registration-transforms/${encodeURIComponent(ctSeriesUid)}/${encodeURIComponent(petSeriesUid)}`);
    }
    catch (error) {
        if (error instanceof ApiError && error.status === 404) {
            return null;
        }
        throw error;
    }
}
export async function putRegistrationTransform(ctSeriesUid, petSeriesUid, transform) {
    return apiFetch(`/registration-transforms/${encodeURIComponent(ctSeriesUid)}/${encodeURIComponent(petSeriesUid)}`, {
        method: 'PUT',
        body: JSON.stringify({ transform }),
    });
}
export async function deleteRegistrationTransform(ctSeriesUid, petSeriesUid) {
    return apiFetch(`/registration-transforms/${encodeURIComponent(ctSeriesUid)}/${encodeURIComponent(petSeriesUid)}`, {
        method: 'DELETE',
    });
}
